interface SentryFallbackProps {
  error: unknown;
  resetError: () => void;
}

export default function SentryFallback({ resetError }: SentryFallbackProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <div className="max-w-md w-full text-center space-y-4">
        <div className="text-4xl">😕</div>
        <h1 className="text-xl font-semibold text-foreground">
          Une erreur est survenue
        </h1>
        <p className="text-sm text-muted-foreground">
          L'équipe Immovox a été automatiquement prévenue. Vous pouvez recharger la page pour réessayer.
        </p>
        <div className="flex gap-2 justify-center">
          <button
            onClick={() => {
              resetError();
              window.location.reload();
            }}
            className="px-4 py-2 rounded-md bg-primary text-primary-foreground text-sm font-medium hover:opacity-90 transition"
          >
            Recharger la page
          </button>
          <button
            onClick={() => {
              window.location.href = "/";
            }}
            className="px-4 py-2 rounded-md border border-border text-foreground text-sm font-medium hover:bg-muted transition"
          >
            Retour à l'accueil
          </button>
        </div>
      </div>
    </div>
  );
}
